var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.581 0.00767722L24.7166 0L24.883 0.0102361L24.9981 0.0307086L25.1555 0.0754921L25.2924 0.13435L25.4204 0.207283L25.5355 0.293012L25.6405 0.388976L25.707 0.464468L25.8119 0.612894L25.8784 0.735728C25.9386 0.863681 25.977 0.999311 25.9936 1.14006L26 1.27569C26 1.37165 25.9898 1.46634 25.9693 1.55718L25.9245 1.71457L17.5666 24.8446C17.4082 25.1895 17.1541 25.4817 16.8345 25.6865C16.515 25.8913 16.1433 26.0001 15.7638 26C15.4219 26.0011 15.0856 25.9136 14.7876 25.7461C14.4896 25.5786 14.2401 25.3368 14.0633 25.0442L13.9801 24.8817L9.69114 16.3063L1.15669 12.0378C0.840907 11.8934 0.568575 11.6686 0.366934 11.3859C0.165293 11.1032 0.0414105 10.7725 0.00767722 10.4269L0 10.2362C0 9.51968 0.385138 8.86456 1.07608 8.48326L1.25522 8.3937L24.3085 0.0690943L24.4441 0.0307086L24.581 0.00767722Z",
    fill: "#85BE49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/Direction.5c5c70194a5ce006aa163d9d29b486bc.svg";
export { ForwardRef as ReactComponent };